import React, { createContext, useContext, useState } from 'react';

import { TMaterializedCitation } from '@/services/types/agent-chat-types';

export interface SelectedCitation {
  materializedCitation: TMaterializedCitation;
  selectedBlockId: string;
}

interface DemandCitationContextType {
  selectedCitation: SelectedCitation | null;
  setSelectedCitation: (c: SelectedCitation | null) => void;
}

const DemandCitationContext = createContext<
  DemandCitationContextType | undefined
>(undefined);

export const DemandCitationProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const [selectedCitation, setSelectedCitation] =
    useState<SelectedCitation | null>(null);

  const contextValue = React.useMemo(
    () => ({ selectedCitation, setSelectedCitation }),
    [selectedCitation],
  );

  return (
    <DemandCitationContext.Provider value={contextValue}>
      {children}
    </DemandCitationContext.Provider>
  );
};

export const useDemandCitation = () => {
  const ctx = useContext(DemandCitationContext);
  if (!ctx) {
    throw new Error(
      'useDemandCitation must be used within DemandCitationProvider',
    );
  }
  return ctx;
};
